import { useCallback } from 'react'
//
import { Wrapper } from './Styled'
import Base64Image from 'component/Base64Image'
import { useNavigateTo } from 'hooks/useNavigateTo'

import themeAssetloadingSmallLoadImagePng from '@theme/loading/small-load-image.png'

const loadingImage = themeAssetloadingSmallLoadImagePng

interface StaticItemProps {
  showName?: boolean
  name?: string
  params?: any
  icon_path?: string
  placeholder?: string
  tall?: boolean
}

export default function StaticItem({ showName, name, params, icon_path, placeholder, tall = false }: StaticItemProps) {
  const { navigateToSecTagList } = useNavigateTo()
  const handleClick = useCallback(() => {
    navigateToSecTagList({
      headerTitle: name as string,
      params: params ?? {},
    })
  }, [name, navigateToSecTagList, params])

  return (
    <Wrapper onClick={handleClick}>
      {/* <Image ref={imgRef} src={loadingImage} tall={tall} /> */}
      <Base64Image
        src={icon_path}
        placeholder={placeholder ?? loadingImage}
        aspectRatio={tall ? 1 / 1.7 : 1}
        noLazy
      ></Base64Image>
      {showName && <span>{name}</span>}
    </Wrapper>
  )
}
